import React, { Component } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
class DynamicDialog extends Component {
  render() {
    const { maxWidth, fullWidth, field, open, title, contentText, actions } = this.props;
    return (
      <>
        {open && (
          <div>
            <Dialog
              maxWidth={maxWidth}
              fullWidth={fullWidth}
              open={open}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">{title}</DialogTitle>
              <DialogContent>
                {contentText && <DialogContentText>{contentText}</DialogContentText>}
                {field}
              </DialogContent>
              <DialogActions>{actions}</DialogActions>
            </Dialog>
          </div>
        )}
      </>
    );
  }
}

export default DynamicDialog;
